<script lang="ts" context="module">
    /**
     *  Do not edit this file, it is auto-generated at build time!
     *  See engine/component-factory.ts to modify the generation of this file.
     *  Note: code-generation is optional! See ./.gitignore for directions to remove it if not needed.
     */

    import ErrorComponent from "@/utils/errorComponent.svelte";

    /** Components */
    import Contact from "@component/content/Contact.svelte";
    import Header from "@component/content/Header.svelte";
    import RichText from "@component/content/RichText.svelte";
    import Units from "@component/content/Units.svelte";

    export const components = {
        Contact: Contact,
        Header: Header,
        RichText: RichText,
        Units: Units,
    }

</script>
<script lang="ts">
    export let rendering;
</script>
{#if components[rendering.componentName]}
    <svelte:component this={components[rendering.componentName]} {...rendering}/>
{:else}
    <ErrorComponent {rendering}/>
{/if}
